import styled from 'styled-components'

export const StyledClinMobileLogoSvg = styled.svg({
  height: 38,
  width: 36
})
